export const vuetifyOptions = {
  icons: {
    iconfont: 'md',
    values: {
      appIcon: 'app-icon'
    },
  },
  theme: {
    themes: {
      light: {
        primary: '#4470B4',
        primary50: '#8EB9FB',
        primary5: '#E3EEFF',
        secondary: '#079E7A',
        secondary50: '#26C8A1',
        secondary5: '#DFFFEC',
        accent: '#FE7E21',
        accent50: '#FFAB6F',
        accent5: '#FFE8D7',
        success: '#00AD07',
        error: '#D40000',
        warning: '#F0D800',
        white: '#FFFFFF',
      }
    }
  }
}